import { useQuery } from 'react-query';

import { getComponentsLibrary as queryFn } from 'api/queries/index';
import { QueryKeys } from 'api/queryKeys';

import { IComponentKey } from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.type';

export const useQueryGetComponentsLibrary = () => {
    return useQuery<QueryFnResponse, QueryError, QueryResponse, [QueryKeys]>({
        queryKey: ['getComponentsLibrary'],
        queryFn: () => queryFn(),
        staleTime: Infinity,
        cacheTime: Infinity,
    });
};

export interface WidgetInLibrary {
    categories: string[];
    componentKey: IComponentKey;
    description: string;
    id: number;
    name: string;
    picture: string;
}

type QueryFnResponse = WidgetInLibrary[];

type QueryResponse = QueryFnResponse & {};
